"use client"

import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import Drawer from "@mui/material/Drawer"
import Typography from "@mui/material/Typography"
import { CancelButton, ConfirmButton, Icons } from "@src/components"
import { useResponsive } from "@src/hooks"
import { OPTION_ALL, SubCategory } from "./tab-category"
import { useState, useEffect } from "react"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import { useTranslation } from "react-i18next"

export default function DrawerSearchMobile(props) {
  const { t } = useTranslation()
  const {
    open,
    currentCategoryId,
    currentSubCategorySlug,
    categories,
    toggleDrawer,
    onSubmitCategory
  } = props
  const { isMobile } = useResponsive()

  const [anchorElMenu, setAnchorElMenu] = useState(null)

  const [selectedMobile, setSelectedMobile] = useState({
    catSlug:
      categories.find(item => item.id === currentCategoryId)?.slug || "all",
    subCatSlug: currentSubCategorySlug || ["all"]
  })

  const tmpSelectData = categories.find(
    item => item.slug === selectedMobile.catSlug
  )
  OPTION_ALL.name = t(OPTION_ALL.key)
  const subCategories = [OPTION_ALL, ...(tmpSelectData?.categories || [])] || [
    OPTION_ALL
  ]

  const handleSelect = slug => {
    setSelectedMobile({
      catSlug: slug,
      subCatSlug: ["all"]
    })
    handleCloseMenu()
  }

  const handleSelectSubCategory = slug => {
    if (slug === "all") {
      setSelectedMobile({
        ...selectedMobile,
        subCatSlug: ["all"]
      })
    } else {
      const newSubCatSlug = selectedMobile.subCatSlug.includes(slug)
        ? selectedMobile.subCatSlug.filter(item => item !== slug)
        : [...selectedMobile.subCatSlug, slug]
      const filterSubCatSlug = newSubCatSlug.filter(item => item !== "all")
      setSelectedMobile({
        ...selectedMobile,
        subCatSlug: filterSubCatSlug?.length === 0 ? ["all"] : filterSubCatSlug
      })
    }
  }

  const handleCloseMenu = () => {
    setAnchorElMenu(null)
  }

  const handleOpenMenu = event => {
    setAnchorElMenu(event.currentTarget)
  }

  const handleSubmit = () => {
    onSubmitCategory(selectedMobile)
    toggleDrawer(false)()
    handleCloseMenu()
  }

  if (!isMobile) return null

  return (
    <Drawer
      sx={{
        "& .MuiPaper-root": {
          width: "80%",
          padding: "24px"
        }
      }}
      open={open}
      onClose={toggleDrawer(false)}
    >
      <Box width="100%" height="100%" pb="40px" position="relative">
        <Stack gap={2} alignItems="center">
          <Icons name="filter" />
          <Typography variant="body1">Lọc</Typography>
        </Stack>
        <Box py={3}>
          <Stack width="100%" role="button" justifyContent="space-between">
            <Typography variant="body1" fontWeight={500}>
              Danh mục
            </Typography>
            <Icons type="button" name="arrow-down" />
          </Stack>
          <Stack
            justifyContent="center"
            width="100%"
            pb="12px"
            sx={{
              borderBottom: "1px solid #00000066"
            }}
            role="button"
            onClick={handleOpenMenu}
          >
            <Typography variant="body1" fontWeight={700} textTransform="uppercase">
              {tmpSelectData?.name}
            </Typography>
          </Stack>
        </Box>
        <Box>
          <Typography mb={1} variant="body1" fontWeight={500}>
            Chi tiết
          </Typography>
          <Stack flexWrap="wrap">
            {(subCategories || []).map(item => (
              <SubCategory
                key={item.id}
                id={item.id}
                name={item.name}
                active={selectedMobile.subCatSlug.includes(item.slug)}
                onSelected={() => handleSelectSubCategory(item.slug)}
              />
            ))}
          </Stack>
        </Box>
        <Stack
          sx={{
            position: "absolute",
            bottom: 0,
            width: "100%"
          }}
          justifyContent="space-between"
          gap="12px"
        >
          <CancelButton
            fullWidth
            label="Chọn lại"
            onClick={toggleDrawer(false)}
          />
          <ConfirmButton fullWidth label="Xác nhận" onClick={handleSubmit} />
        </Stack>
      </Box>
      <Menu
        anchorEl={anchorElMenu}
        open={!!anchorElMenu}
        onClose={handleCloseMenu}
        MenuListProps={{
          "aria-labelledby": "basic-button"
        }}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        sx={{
          "& .MuiPaper-root": {
            width: "calc(80% - 48px)",
            borderRadius: 0,
            padding: 0,
            margin: 0,
            "& ul": {
              padding: 0,
              "& li": {
                borderBottom: "1px solid #E6E6E6",
                textTransform: "uppercase",
                "&.active": {
                  backgroundColor: "#E6E6E6"
                },
                "&:last-child": {
                  borderBottom: "none"
                }
              }
            }
          }
        }}
      >
        {categories.map((item, index) => (
          <MenuItem
            key={index}
            className={selectedMobile.catSlug == item.slug && "active"}
            onClick={() => handleSelect(item.slug)}
          >
            {item.name}
          </MenuItem>
        ))}
      </Menu>
    </Drawer>
  )
}
